import { calculateBoniPoints, truncateBoniPoints } from 'containers/Boni/helpers';
import { BoniInfoEventParams, MapBoniProductItemParams } from './interfaces';
import { handleParseProductList } from '.';

export function mapBoniGtmItem(product: any, interactionType?: string) {
	const {
		hyperaCode,
		ean13,
		description,
		price,
		combo,
		productType,
		businessUnitName,
		promotion_name,
		promotion_id,
		industryName = '',
	} = product;

	return {
		price,
		item_id: combo || productType === 'COMBO' ? hyperaCode : ean13,
		item_name: description,
		promotion_id: promotion_id || hyperaCode || '',
		industry_name: businessUnitName ? 'Hypera' : industryName,
		promotion_name: promotion_name || '',
		...(interactionType ? { interaction_type: interactionType } : {}),
	};
}

export function mapBoniProductItem({
	ean13,
	description,
	businessUnitName,
	price,
	quantity,
	discount,
	affiliation,
	industryName,
	promotionId,
	promotionName,
	itemListName,
	isCombo,
	levelName,
}: MapBoniProductItemParams) {
	return {
		item_id: ean13,
		item_name: description,
		item_variant: businessUnitName || '',
		price,
		quantity,
		discount,
		affiliation,
		promotion_id: promotionId || '',
		promotion_name: promotionName || '',
		industry_name: businessUnitName ? 'Hypera' : industryName!,
		item_list_name: itemListName || undefined,
		is_combo: isCombo,
		boni_points: truncateBoniPoints(calculateBoniPoints(levelName, price)),
	};
}

export function buildBoniInfoEvent({ basketProductsData, boniLevel, cartValue, totalBoniPoints }: BoniInfoEventParams) {
	return {
		boni_level: boniLevel,
		boni_points_amount: totalBoniPoints,
		cart_value: cartValue,
		ecommerce: handleParseProductList(basketProductsData),
	};
}
